<template>
  <Modal
    :title="computedTitle"
    :modal="modalRecurso"
    @close="$emit('close')"
    @save="save"
  >
    <div slot="header-right">
      <v-btn fab small text @click="$emit('close')" class="mr-3">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="primary" @click="save">
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </div>
    <v-row slot="inner-body">
      <v-col>
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="recursoForm"
          lazy-validation
        >
          <Input
            @input="recurso.recurso = $event"
            :value="recurso.recurso"
            label="Recurso"
            name="recurso"
            :rules="[rules.required]"
            :autofocus="modalRecurso"
            required
          />
          <Input
            @input="recurso.descricao = $event"
            :value="recurso.descricao"
            label="Descrição"
            name="descricao"
          />
        </v-form>
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '../shared/Modal';
import Recurso from '@/domain/Recurso';
import Input from '@/components/shared/Input';

export default {
  name: 'ModalRecurso',
  props: {
    modalRecurso: {
      type: Boolean,
      default: false
    },
    editRecurso: {
      default: null
    }
  },
  components: {
    Modal,
    Input
  },
  data: () => ({
    valid: true,
    recurso: new Recurso()
  }),
  watch: {
    modalRecurso(value) {
      if (!value) this.recurso = new Recurso();
    },
    editRecurso(value) {
      if (value) this.recurso = value;
    }
  },
  computed: {
    ...mapGetters(['loading', 'rules']),
    computedTitle() {
      return this.editRecurso ? 'Edita Recurso' : 'Novo Recurso';
    }
  },
  methods: {
    ...mapActions(['addRecurso', 'updateRecurso']),
    async save() {
      if (this.$refs.recursoForm.validate()) {
        if (this.editRecurso) {
          const success = await this.updateRecurso({ ...this.recurso });
          if (!success) return;
          this.$emit('close');
        } else {
          const success = await this.addRecurso({ ...this.recurso });
          if (!success) return;
          this.$emit('close');
        }
      }
    }
  }
}
</script>

<style>

</style>